export default __webpack_public_path__ + "static/media/logoHorizontal.bd9c4a55.png";